import cookie from 'browser-cookies';

export const isDeviceNative = () => {
  const deviceCookie = cookie.get('wh_device') || '{}';
  const { is_native: isNative } = JSON.parse(deviceCookie);
  return isNative === 'true' || isNative === true;
};

export default {
  isDeviceNative,
};
